import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeFrBe from '@angular/common/locales/fr-BE';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import { NgModule } from '@angular/core';

import { MetaReducer, StoreModule } from '@ngrx/store';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import AggregateMiddleware from '@common/services/middleware/aggregate.middleware';
import { rootReducer } from '@reducers/root.reducer';
import { AgmCoreModule } from '@duxor/agm-core';
import { APP_NAME_TOKEN, CustomTranslateLoader } from '@language';
import {
    createLocalStorageSyncReducer,
    HttpService,
    LocalStoragePrefix,
    SharedModule,
    ToastsModule,
    TrackingModule
} from '@mediahaven/shared';
import { CORE_APP_MODULES, ShCoreAppModule } from '@stylehaven/components';
import { BootstrapRoutingModule } from './bootstrap-routing.module';
import { RootContainerComponent } from './containers/root-container.component';
import { BOOTSTRAP_PROVIDERS, DEFERRED_COMPILER } from './sub-modules/bootstrap-providers';

registerLocaleData(localeNlBe);
registerLocaleData(localeNl);
registerLocaleData(localeFrBe);
registerLocaleData(localeDe);

const metaReducers: MetaReducer<any>[] = [
    createLocalStorageSyncReducer({
        localStoragePrefix: LocalStoragePrefix.Portal
    })
];
@NgModule({
    declarations: [RootContainerComponent],
    imports: [
        // Core App imports
        ...CORE_APP_MODULES,
        ShCoreAppModule.forRoot(HttpService),
        BootstrapRoutingModule,
        StoreModule.forRoot(rootReducer, { metaReducers }),

        // MH Shared imports
        SharedModule.forRoot(HttpService, AggregateMiddleware),

        // App specific imports
        AgmCoreModule.forRoot(),
        ToastsModule,
        TrackingModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                deps: [APP_NAME_TOKEN]
            },
            compiler: {
                provide: TranslateCompiler,
                useValue: DEFERRED_COMPILER
            }
        })
    ],
    providers: [...BOOTSTRAP_PROVIDERS],
    bootstrap: [RootContainerComponent]
})
export class BootstrapModule {}
